module.exports = "/newsfeed/components/newsfeed-notifications-6231cc.html";